import { createContext } from "react";
import type { TableSortContextType } from "../TableSortProvider.types";

const TableSortContext = createContext<TableSortContextType | undefined>(undefined);
TableSortContext.displayName = "TableSortContext";

export default TableSortContext;
